import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import ClosePopupIcon from "../../../assets/icons/close-new.svg";
import DownloadIcon from "../../../assets/icons/download-icon.svg";
import { Overlay } from "../../../components";
import { motion } from "framer-motion";
import { AppBar, Box, Toolbar } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";

// Set worker once at module level — served locally to avoid CSP issues
// File is copied to frontend/dist/js/ by the postbuild npm script
pdfjs.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.mjs';

const PDFViewer = ({ openModal, onClose }) => {
  const [numPages, setNumPages] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () => {
    setPageNumber(pageNumber - 1);
  };
  const goToNextPage = () => {
    setPageNumber(pageNumber + 1);
  };

  const downloadResource = () => {
    // If no filename is set, use filename from URL
    const url = "/api/user/documents/User_guide_CrosscopeDx.pdf";
    const filename = url.match(/\/([^/#?]+)[^/]*$/)[1];
    fetch(url, {
      headers: new Headers({
        Origin: window.location.origin,
      }),
      mode: "cors",
    })
      .then((response) => response.blob())
      .then((blob) => forceDownload(blob, filename))
      .catch((e) => console.error(e));
  };
  const forceDownload = (blob, filename) => {
    // Create an invisible anchor element
    const anchor = document.createElement("a");
    anchor.style.display = "none";
    anchor.href = window.URL.createObjectURL(blob);
    anchor.setAttribute("download", filename);
    document.body.appendChild(anchor);

    // Trigger the download by simulating click
    anchor.click();

    // Clean up
    window.URL.revokeObjectURL(anchor.href);
    document.body.removeChild(anchor);
  };

  return (
    openModal && (
      <React.Fragment>
        <Overlay />

        <div className="modal_big">
          <div className="user-guide-modal">
            <motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ duration: 0.3 }}
>
              <div style={{ minWidth: "400px", zIndex: "9" }}>
                <CssBaseline />

                <AppBar
                  position="fixed"
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, background: "#ffffff", color: "#0F0DA1", fontWeight: 700, border: "none" }}
                >
                  <Toolbar className="prompt-top">
                    <span className="prompt-title">User guide</span>

                    <div className="pageChanger">
                      <span>{numPages} pages</span>
                    </div>

                    <div className="downloadAndClose">
                      <img
                        className="download-icon"
                        src={DownloadIcon}
                        onClick={downloadResource}
                      />
                      <img
                        className="close-icon"
                        src={ClosePopupIcon}
                        onClick={() => {
                          onClose(false);
                        }}
                      />
                    </div>
                  </Toolbar>
                </AppBar>

                <Box component="main" sx={(theme) => ({ flexGrow: 1, padding: theme.spacing(2, 0), alignContent: "center", userSelect: "none" })}>
                  <div className="modal_middle">
                    <div className="pdf-content">
                      <Document
                        file={"/api/user/documents/User_guide_CrosscopeDx.pdf"}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={(err) => console.error('PDF load error:', err)}
                      >
                        {numPages &&
                          Array.apply(null, Array(numPages))
                            .map((x, i) => i + 1)
                            .map((page) => (
                              <Page
                                key={page}
                                pageNumber={page}
                                width={1000}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                                loading={
                                  page !== 1 ? null : (
                                    <div className="pdf-loader">
                                      Please wait!
                                    </div>
                                  )
                                }
                              />
                            ))}
                      </Document>
                    </div>
                  </div>
                </Box>
              </div>
            </motion.div>
          </div>
        </div>
      </React.Fragment>
    )
  );
};

export default PDFViewer;
